<template src="./home.html"></template>

<script>
import NewLatest from 'Components/new-latest/NewLatest.vue';
import ListInterShip from 'Components/intership_top/ListInterShip.vue';
import JobInternTOP from 'Components/job_intern_top/ListJobInternTop.vue';
import SchoolTop from 'Components/blog_top/ListBlog.vue';
import ServiceTOP from 'Components/service_top/ListServiceTop.vue';
import Videos from 'Components/video_top/Video.vue';
import InternTOP from 'Components/intern_top/ListInternTop.vue';


export default {
  components: {
    NewLatest,
    ServiceTOP,
    ListInterShip,
    JobInternTOP,
    SchoolTop,
    InternTOP,
    Videos,
  },
};
</script>
